








import Vue, { CreateElement, VNode, Component } from "vue";
// View
import Overview from "@/views/Dashboard/Management/Overview.vue";
import User from "@/views/Dashboard/Administration/User.vue";
import Device from "@/views/Dashboard/Management/Device/Device.vue";
import DeviceTabs from "@/views/Dashboard/Management/Device/DeviceTabs.vue";
import Logs from "@/views/Dashboard/Management/Logs.vue";
import Survey from "@/views/Dashboard/Management/Survey/Survey.vue";
import SurveyDescription from "@/views/Dashboard/Management/Survey/SurveyDescription.vue";
import PosteDescription from "@/views/Dashboard/Management/Poste/PosteDescription.vue";

interface DashboardComponent {
  name: string;
  component: Component;
}

interface DashboardContentData {
  link: Location;
  dashboardComponent: Array<DashboardComponent>;
}

export default Vue.extend({
  name: "DashboardContent",
  data: (): DashboardContentData => ({
    link: window.location,
    dashboardComponent: [
      { name: "dashboard", component: Overview },
      { name: "users", component: User },
      { name: "devices", component: Device },
      { name: "device", component: DeviceTabs },
      { name: "logs", component: Logs },
      { name: "surveys", component: Survey },
      { name: "survey", component: SurveyDescription },
      { name: "poste", component: PosteDescription }
    ]
  }),
  render: function (createElement: CreateElement): VNode {
    // This function is rendering the right component by checking what kind of url is specified
    // Exemple : http://.../users is giving us the "users" result and by matching the dashboardComponent array
    // the function is gonna return a component
    const local = location
      .toLocaleString()
      .replace((process.env["VUE_APP_URL"] as string) + "/", "")
      .split("?")[0]
      .split("#")[0];
    return createElement("div", { class: "raw centered_content" }, [
      createElement(
        this.dashboardComponent.find((component: DashboardComponent) => component.name === local)?.component
      )
    ]);
  }
});
